import styled from 'styled-components'
import { Settings } from 'react-feather'

export const TradeWrapper = styled.div`
  width: 100%;
  padding: 6px;
  border-radius: 20px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
  background: ${({ theme }) => theme.bg1};
`

export const TradeHeader = styled.div`
  padding-bottom: 18px;
  border-bottom: solid 1px #edf1f5;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.53px;
  color: ${({ theme }) => theme.text1};
`

export const StyledMenuIcon = styled(Settings)`
  height: 20px;
  width: 20px;
  > * {
    stroke: ${({ theme }) => theme.text1};
  }
  :hover {
    opacity: 0.7;
    cursor: pointer;
  }
`

export const AppBodyFull = styled.div`
  position: relative;
  // max-width: 420px;
  width: 100%;
  background: ${({ theme }) => theme.bg1};
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
  border-radius: 20px;
  /* padding: 1rem; */
  z-index: 1;
`